import { useNavigate } from "react-router-dom";

import { Button, Modal, Text } from "@pentabd/ui";
import { IconCheckCircle } from "@pentabd/icons";

interface SuccessModalType {
  closeAble?: boolean;
  isModalOpen: boolean;
  title?: string;
  subtitle?: string;
  redirectPath?: string;
  action?: () => void;
}

export const SuccessModal = ({
  closeAble = false,
  isModalOpen,
  title = "Success",
  subtitle = "",
  redirectPath,
  action,
}: SuccessModalType) => {
  const navigate = useNavigate();

  const onClickAction = () => {
    redirectPath && navigate(redirectPath);
    action && action();
  };

  return (
    <Modal
      isOpen={isModalOpen}
      overlay={isModalOpen}
      onClose={onClickAction}
      closeAble={closeAble}
      portal
    >
      <div className="p-10 w-100">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <IconCheckCircle size="40" fill="success" />
          <Text
            color="dark"
            size="lg"
            className="pt-8 fs-lg fw-semibold"
            component="p"
          >
            {title}
          </Text>
          <Text color="subtitle1" size="sm" className="pt-2" component="p">
            {subtitle}
          </Text>
        </div>

        <div className="w-max mx-auto mt-10">
          <Button
            key="close"
            className="px-18"
            size="sm"
            htmlType="button"
            fill="fill"
            type="primary"
            onClick={onClickAction}
          >
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
};
